module.exports = __webpack_public_path__ + "montserrat-okta-regular-webfont.69eac499e9311b03ed69199e62ea962e.ttf";